import React, { useState } from 'react';
import { Select } from 'antd';

function MultiSelect({ list, onSelect, selected, labelField, valueField, required = false, placeholder = "Select", isObject = true, fontSize = '13px', disabled = false }) {
    const [searchText, setSearchText] = useState('');

    const options = (list ?? []).map(item => ({
        label: isObject ? (item?.[labelField] ?? '') : (item ?? ''),
        value: isObject ? item?.[valueField] : item,
        item,
    }));

    const currentValues = (selected ?? []).map(s => isObject ? s?.[valueField] : s).filter(v => v !== undefined && v !== null);

    return (
        <Select
            mode="multiple"
            showSearch
            allowClear
            disabled={disabled}
            placeholder={placeholder}
            value={currentValues}
            options={options}
            size="middle"
            style={{ width: '100%', fontSize, minHeight: '40px' }}
            styles={{ popup: { root: { fontSize } } }}
            filterOption={(input, option) =>
                (String(option?.label ?? '')).toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(a, b) => {
                if (!searchText) return 0;
                const lower = searchText.toLowerCase();
                const idxA = (String(a.label ?? '')).toLowerCase().indexOf(lower);
                const idxB = (String(b.label ?? '')).toLowerCase().indexOf(lower);
                return idxA - idxB;
            }}
            onSearch={setSearchText}
            onChange={(vals, options) => {
                setSearchText('');
                onSelect(options.map(o => o.item));
            }}
        />
    );
}

export default MultiSelect;
